(function () {
  function normalize(str) {
    return (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function getSelectedColor(container) {
    // Dawn: intenta leer el variant picker (swatches/radios/select)
    const colorFieldset = container.querySelector('fieldset[data-option-name="Color"]');
    if (colorFieldset) {
      const checked = colorFieldset.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
    }

    // fallback: primer fieldset de radios
    const anyChecked = container.querySelector('fieldset input[type="radio"]:checked');
    if (anyChecked) return anyChecked.value;

    // fallback: select
    const select = container.querySelector('select[name="options[Color]"]');
    if (select) return select.value;

    return null;
  }

  function getAltFromMediaItem(mediaItem) {
    // Busca alt en img o en picture/source
    const img = mediaItem.querySelector("img");
    if (img && img.getAttribute("alt")) return img.getAttribute("alt");
    return "";
  }

  function matchesColor(alt, selectedColor) {
    // Si no hay corchetes => la mostramos siempre (genérica)
    const hasBracket = /\[[^\]]+\]/.test(alt);
    if (!hasBracket) return true;

    const m = alt.match(/\[([^\]]+)\]/);
    if (!m) return true;

    const tagColor = normalize(m[1]);
    const sel = normalize(selectedColor);
    return tagColor === sel;
  }

  function filterGallery(section) {
    const productRoot =
      section.querySelector("product-info") ||
      section.querySelector(".product") ||
      section;

    const selectedColor = getSelectedColor(productRoot);
    if (!selectedColor) return;

    // Media items (carrusel principal)
    const mediaItems = section.querySelectorAll(".product__media-item");
    mediaItems.forEach((item) => {
      const alt = getAltFromMediaItem(item);
      const show = matchesColor(alt, selectedColor);
      item.style.display = show ? "" : "none";
    });

    // Thumbnails
    const thumbs = section.querySelectorAll(".thumbnail-list__item");
    thumbs.forEach((thumb) => {
      const img = thumb.querySelector("img");
      const alt = img ? img.getAttribute("alt") || "" : "";
      const show = matchesColor(alt, selectedColor);
      thumb.style.display = show ? "" : "none";
    });

    // Si la imagen activa está oculta, fuerza click en la primera visible
    const activeMedia = section.querySelector(".product__media-item.is-active");
    if (activeMedia && activeMedia.style.display === "none") {
      const firstVisibleThumb = Array.from(section.querySelectorAll(".thumbnail-list__item"))
        .find((t) => t.style.display !== "none");
      if (firstVisibleThumb) {
        const btn = firstVisibleThumb.querySelector("button, a");
        if (btn) btn.click();
      }
    }
  }

  function init() {
    const sections = document.querySelectorAll('[id^="MainProduct-"], .shopify-section');
    sections.forEach((section) => {
      // Filtra al cargar
      filterGallery(section);

      // Re-filtra cuando cambie variante
      section.addEventListener("change", (e) => {
        if (e.target && (e.target.name || "").includes("options")) {
          setTimeout(() => filterGallery(section), 50);
        }
        if (e.target && e.target.type === "radio") {
          setTimeout(() => filterGallery(section), 50);
        }
      });

      // Dawn dispara eventos internos, por si acaso:
      section.addEventListener("variant:change", () => setTimeout(() => filterGallery(section), 50));
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
